export default {
  customers: "Customers",
  events: "Events",
  orders: "Orders",
  leads: "Leads",
  globaltags: "Global Tags",
};
